import { render, staticRenderFns } from "./AuthScreen.vue?vue&type=template&id=5a4c81f6&scoped=true&"
import script from "./AuthScreen.vue?vue&type=script&lang=js&"
export * from "./AuthScreen.vue?vue&type=script&lang=js&"
import style0 from "./AuthScreen.vue?vue&type=style&index=0&id=5a4c81f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c81f6",
  null
  
)

export default component.exports